import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import SubCompanyListModuleTypes from '@/store/modules/middleGround/member/subCompanyList/interface';

const subCompanyListModule: Module<SubCompanyListModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        pageCompanyList(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/pageCompanyList", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        saveSubCompany(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/saveSubCompany", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        updateCompanyStatus(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/updateCompanyStatus", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        
    },
};

export default subCompanyListModule;